import MathUtils from '../../../utils/MathUtils';
import type { SolverStrategy, StrategyInput, StrategyOutput } from '../types';

export class SolverRandomStrategy implements SolverStrategy {
  public readonly label = 'random';

  public getNextMove(input: StrategyInput): StrategyOutput {
    const { boardModel, trayModel } = input;
    const fromIndex = trayModel.getItems().findIndex((s) => s.hasTiles());

    if (fromIndex === -1) {
      console.log({ input });
      throw new Error('Cannot find from model - all stacks empty');
    }
    const emptyStack = MathUtils.rnd.pick(boardModel.getEmptyStacks());

    return {
      fromStack: fromIndex,
      toStack: { x: emptyStack.x, y: emptyStack.y },
    };
  }
}
